// extracted by mini-css-extract-plugin
export default {"example":"ExamplePage_example__X4XMd","title":"ExamplePage_title__rq3OT"};